/**
 * Version Badge Component
 * Displays the current application version
 */

import React from 'react'

export default function VersionBadge({ className = '' }) {
  const baseVersion = import.meta.env.VITE_APP_VERSION || '1.0.0'
  
  // Show dev version when running on localhost or in dev mode
  const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development'
  const isLocalhost = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || 
     window.location.hostname === '127.0.0.1' ||
     window.location.hostname === '[::1]')
  
  const version = (isDev || isLocalhost) ? '0.0.0-dev' : baseVersion
  
  return (
    <span className={`text-xs text-gray-500 ${className}`}>
      v{version}
    </span>
  )
}
